export default __webpack_public_path__ + "static/media/card-image12.ad844118.png";